import { useConfig as hook } from '@eika-infrastruktur/config-provider';

const defaultTexts = {
    cardHeader: 'Finn bilforsikringen som passer deg',
    introInfo: 'Ta en kort test for å finne riktig bilforsikring til ditt behov.',
    buttonStartText: 'Start test',
    buttonNextText: 'Neste',
    buttonBackText: 'Tilbake',
    buttonSeeResultText: 'Se resultat',
    advisorText: 'Rådgiver',
    result: 'Resultat',
    carInsurance: 'bilforsikring passer best',
    tryAgain: 'Ta testen på nytt',
    disclaimer1: 'Denne testen er kun veiledende, det er viktig å lese seg opp på ',
    disclaimer2: ' før du bestemmer deg for hvilken forsikring du bør ha. '
};

const defaultQuestions = {
    q1: {
        question: 'Hvor gammel er bilen din - eller den du har tenkt til å kjøpe?',
        alternatives: 'Under 3 år|Mellom 4-9 år|Over 10 år',
        descriptions:
            'Hvis bilen din er under 3 år gammel kan du ha rett til ny bil hvis det er veldig dyrt å reparere bilen etter en skade. Forsikringen Bil Pluss dekker dette i 3 år, og Kasko i 1 år.' +
            '|Hvis bilen din er av nyere årgang eller en viss verdi vil vi anbefale minst Kasko på den, men biler med lav verdi, høy kilometerstand etc. kan etter noen år også ha tilfredsstillende dekning med Delkasko. ' +
            '|Hvis du har en eldre bil er det ikke alltid det lønner seg å reparere den hvis skadene er store. Da kan forsikringene våre Delkasko eller Ansvar passe for deg.',
        scores: '300|20|1',
        clarification: null
    },
    q2: {
        question: 'Har du billån* på bilen din - eller den du har tenkt til å kjøpe?',
        alternatives: 'Ja|Nei',
        descriptions:
            'Hvis du har billån kan du velge mellom forsikringene våre Bil Pluss og Kasko (med eller uten leiebil).' +
            '|Hvis du ikke har billån kan du velge mellom alle forsikringene våre; Bil Pluss, Kasko (med eller uten leiebil), Delkasko og Ansvar.',
        scores: '300|1',
        clarification: '*Gjelder kun lån som er tatt opp eller skal tas opp med sikkerhet i bil.'
    },
    q3: {
        question: 'Hva er viktigst for deg av disse alternativene?',
        alternatives:
            'God dekning på forsikring er viktigere enn pris|Pris er viktigere enn god dekning|En kombinasjon',
        descriptions:
            'Med Bil Pluss får du ekstra trygghet og hjelp i uforutsette situasjoner.' +
            '|Det er viktig at man har råd til å fikse skader på egen bil hvis man velger en lav månedspris. Med Delkasko og Ansvar må du selv dekke skade på egen bil.' +
            '|Kasko (med eller uten leiebil) har god dekning og er litt rimeligere i måneden enn Bil Pluss. En fin kombinasjon som passer mange.',
        scores: '50000|1|20',
        clarification: null
    },
    q4: {
        question: 'Tenk deg at bilen din må på verksted på grunn av en skade. Trenger du leiebil da?',
        alternatives: 'Ja, uansett hvor lang tid det tar|Ja, men en ukes tid er nok|Nei',
        descriptions:
            'Noen ganger kan det ta ekstra lang tid å fikse bilen. Bil Pluss sørger for at du har leiebil så lenge du trenger det.' +
            '|Med Kasko m/leiebil får du leiebil i inntil 10 dager.' +
            '|Det er viktig å være klar over at det er vanskelig å få leiebil dekket av motpart. Da må du kunne dokumentere behovet ditt.',
        scores: '50000|4000|1',
        clarification: null
    },
    q5: {
        question: 'Tenk deg at bilen din stopper midt på motorveien. Vil du at forsikringen skal dekke veihjelp? ',
        alternatives: 'Ja|Nei',
        descriptions:
            'Med Bil Pluss, Kasko (med eller uten leiebil) og Delkasko får du veihjelp hvis du trenger det. Egenandel for det er 500 kroner.' +
            '|Med Ansvar er du bare dekket for det som er lovpålagt. Hvis du får veiproblemer må du da dekke denne kostnaden selv.',
        scores: '20|1',
        clarification: null
    },
    q6: {
        question:
            'Noen har vært borti bilen din på en parkeringsplass uten å gi beskjed. Vil du at forsikringen skal dekke skaden?',
        alternatives: 'Ja|Nei',
        descriptions:
            'Med Bil Pluss og Kasko (med eller uten leiebil) dekker vi skaden uansett hvem som har skylden.' +
            '|Med Delkasko og Ansvar er du dekket hvis du skader noen andre, men egen bil må du fikse selv.',
        scores: '300|1',
        clarification: null
    },
    q6b: {
        question:
            'Skader på parkert bil er en av de mest vanlige skadene. Vil du at forsikringen skal dekke det med eller uten bonustap? ',
        alternatives: 'Uten bonustap|Med bonustap',
        descriptions:
            'Bil Pluss dekker parkeringsbulker på inntil 20 000 kroner.' +
            '|Kasko (med eller uten leiebil) dekker parkeringsbulker med inntil 10% bonustap. Det betyr at månedsprisen din kan øke noe neste år.',
        scores: '50000|300',
        clarification: null
    },
    q7: {
        question:
            'Hvis du er uheldig og fyller feil drivstoff eller mister nøklene dine; vil du at forsikringen skal dekke det?',
        alternatives: 'Ja|Nei',
        descriptions:
            'Med Bil Pluss får du ekstra trygghet og hjelp i uforutsette situasjoner.' +
            '|Hvis du fyller feil bensin er det viktig å ringe veihjelp med en gang.',
        scores: '50000|1',
        clarification: null
    }
};

const defaultResults = {
    resultBilPluss:
        'Bil Pluss|Med Bil Pluss er den beste forsikringen vår. Her får du ekstra trygghet og hjelp i uforutsette situasjoner. Du er dekket for uhell uansett hvem som har skylden og på parkeringsbulker slipper du til og med bonustap. Passer perfekt for deg som har ny bil.|Med Bil Pluss betaler du mindre i egenandel ved skader som skjer ved kollisjon, utforkjøring og velting.',
    resultKaskoMedLeiebil:
        'Kasko m/ leiebil|Kasko passer de fleste, og for deg som ønsker leiebil ved verkstedopphold grunnet skade er Kasko/m leiebil å anbefale. Forsikringen dekker deg hvis du har et uhell - uansett hvem som har skylden. Du er også dekket for skade på ekstrautstyr, motor og elektronikk og tap av bagasje.|Ønsker du leiebil i mer enn 10 dager, anbefaler vi Bil Pluss.',
    resultKasko:
        'Kasko|Kasko er den forsikringen som passer de fleste. Forsikringen dekker deg hvis du har et uhell - uansett hvem som har skylden. Du er også dekket for skade på ekstrautstyr, motor og elektronikk og tap av bagasje.|Kasko gir en god balanse mellom pris og dekning.',
    resultDelkasko:
        'Delkasko|Med Delkasko får du en grunnleggende forsikring som dekker ditt ansvar hvis du er uheldig. Her er du vanligvis dekket for skader som skyldes brann, tyveri og glasskader. Du får i tillegg veihjelp når du trenger det med en egenandel på 500 kroner.|Det er viktig å vite at Delkasko ikke dekker skader på egen bil hvis du for eksempel har en utforkjøring. Hvis du har et uhell med en motpart og det ikke er din skyld dekkes skaden av motpart.',
    resultAnsvar:
        'Ansvar|For å få lov til å kjøre bilen din må du ha minimum Ansvarsforsikring. Ansvar er den rimeligste forsikringen vi har, her er du dekket for personskade og fører- og passasjerulykke. Ved kollisjon dekkes utgifter til motpart, men ikke på egen bil. Du får også rettshjelp ved behov.|Hvis bilen din har en veldig lav verdi er det ikke sikkert at det lønner seg å reparere skadene hvis de er for store - da kan Ansvar være et alternativ for deg.'
};
const defaultResultLimits = '20|300|4000|50000';

interface Link {
    target?: string;
    text?: string;
    url: string;
}

interface Config {
    links: {
        disclaimerLink?: Link;
    };
    texts: typeof defaultTexts;
    questions: typeof defaultQuestions;
    results: typeof defaultResults;
    resultLimits: string;
}

export const defaultConfig: Config = {
    links: {},
    texts: defaultTexts,
    questions: defaultQuestions,
    results: defaultResults,
    resultLimits: defaultResultLimits
};

export const useConfig = () => hook<typeof defaultConfig>();
